import React, { Component } from 'react';
import Modal from '../Modal/index';
import { triggerError } from 'actions/gallery';
import i18n from 'i18n';

type ReduxProps = ReturnType<typeof stateToProps>;

export const stateToProps = ({ triggerError } : { triggerError: any}) => ({
  error: triggerError
});

export const dispatchToProps = (dispatch: any) => ({
  removeError: () => {
    dispatch(triggerError(null));
  }
});

interface ErrorModalProps extends ReduxProps {
  removeError: () => void;
}

export default class ErrorModal extends Component<ErrorModalProps> {
  removeError = () => {
    this.props.removeError();
  };

  render() {
    const { error } = this.props;

    let title = error.title;
    if (!title && error.titleKey) {
      title = i18n(error.titleKey)();
    }

    let message = error.message;
    if (!message && error.messageKey) {
      message = i18n(error.messageKey)();
    }

    return (
      <Modal
        id="ErrorModal"
        title={title}
        contentAbove={message}
        onClose={this.removeError}
        buttons={[
          {
            text: i18n('component.ErrorModal.okButtonText')(),
            id: 'remove-error-button',
            onClick: this.removeError
          }
        ]}
      />
    );
  }
}
